import Cookies from "js-cookie";

export async function JSONRequest<Data extends unknown | undefined>(
  url: string,
  init: RequestInit = { method: "GET" }
) {
  const csrftoken = Cookies.get("csrftoken");

  const response = await fetch(url, {
    credentials: "same-origin",
    ...init,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": csrftoken || "",
      ...init.headers,
    },
  });

  const text = await response.text();
  let body: unknown;

  try {
    body = text ? JSON.parse(text) : undefined;
  } catch (e) {
    throw new Error("Unable to parse API response", {
      cause: e,
    });
  }

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return body as Data;
}
